import { connect } from 'react-redux';
import TransactionsModal from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(TransactionsModal);
